import { render, staticRenderFns } from "./ProfileUpdateForm.vue?vue&type=template&id=2bae8f0f"
import script from "./ProfileUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileUpdateForm.vue?vue&type=style&index=0&id=2bae8f0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports